import axios from 'axios'
import { config, url } from '@/store'

// Список
const getApproveList = (params, type) => {
  return axios.get(`${url}/approve?type=${type}&user_id=${params.userId}&expand=treaty,user,comments,approve,treaty,responsibles,controls,files&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.currentTake}&page=${params.currentPage}`, config)
}
const getApproveListPrevPage = (params, type) => {
  return axios.get(`${url}/approve/?type=${type}&user_id=${params.userId}&expand=treaty,user,comments,approve,treaty,responsibles,controls,files&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.currentTake}&page=${params.currentPage - 1}`, config)
}
const getApproveListNextPage = (params, type) => {
  return axios.get(`${url}/approve/?type=${type}&user_id=${params.userId}&expand=treaty,user,comments,approve,treaty,responsibles,controls,files&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.currentTake}&page=${params.currentPage + 1}`, config)
}
const getApproveListPage = (params, type) => {
  return axios.get(`${url}/approve/?type=${type}&user_id=${params.userId}&expand=treaty,user,comments,approve,treaty,responsibles,controls,files&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.currentTake}&page=${params.currentPage}`, config)
}
const deleteApproveItem = (orderId) => {
  return axios.delete(`${url}/approve/${orderId}`, config)
}

// Апдейт\Создание
const getApproveItem = (id) => {
  return axios.get(`${url}/approve/${id}?expand=treaty,user,comments,approve,treaty,responsibles,controls,files`, config)
}

const postApproveItem = (createData) => {
  return axios.post(`${url}/approve`, createData, config)
}
const putApproveItem = (createData, id) => {
  return axios.put(`${url}/approve/${id}`, createData, config)
}
const postApproveComments = (id, commentData) => {
  return axios.post(`${url}/approve/${id}/comment`, commentData, config)
}
const putApproveComments = (id, commentData, commentId) => {
  return axios.put(`${url}/approve/${id}/comment/${commentId}`, commentData, config)
}
const deleteApproveComments = (id, commentId) => {
  return axios.delete(`${url}/approve/${id}/comment/${commentId}`, config)
}
const getApproveReport = (params) => {
  return axios.get(`${url}/approve/${params.id}/report?type=${params.type}`, config)
}
const voteApprove = (id, params) => {
  return axios.post(`${url}/approve/${id}/vote`, params, config)
}

export default {
  getApproveList,
  getApproveItem,
  postApproveItem,
  putApproveItem,
  postApproveComments,
  putApproveComments,
  deleteApproveComments,
  getApproveReport,
  deleteApproveItem,
  getApproveListPrevPage,
  getApproveListNextPage,
  getApproveListPage,
  voteApprove
}
